import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'distance'
})
export class DistancePipe implements PipeTransform {

  private readonly conversationTable = {
    m: {
      km: 0.001,
      m: 1
    },
    km: {
      km: 1,
      m: 1000
    }
  }

  transform(distance: number, from: string = 'km', to: string = 'auto'): any {
    if (to === 'auto') {
      if (from === 'km') {
        if (distance < 1) {
          to = 'm'
        } else {
          to = 'km'
        }
      } else if (from === 'm') {
        if (distance >= 1000) {
          to = 'km'
        } else {
          to = 'm'
        }
      } else {
        to = 'km'
      }
    }

    distance *= this.conversationTable[from][to]

    if (to === 'm') {
      return distance.toFixed(0) + ' ' + to
    } else {
      return distance.toFixed(2) + ' ' + to
    }

  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/distance/distance.pipe.ts